import { useState, useEffect } from "react";
// import '../styles/Body.css'
// import {Helmet} from "react-helmet";
import { useParams, useHistory } from "react-router-dom";
import db from "../firebase";
import {Card, ListGroup} from 'react-bootstrap'

function Receipt(){

    const {code} = useParams()
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [date, setDate] = useState('')
    const [description, setDescription] = useState('')
    const [approved, setApproved] = useState()
    const [apText, apTextSet] = useState('')
    const [phone, setPhone] = useState('')
    // const [id, setID] = useState('')
    // const [loading, setLoading] = useState(true)

    const history = useHistory()

    useEffect(() => {
        let query = db.collection('data').where("code", "==", code);
        query.onSnapshot((data) => {
            if(data.empty){
                return history.push('/404')
                
            }
            // setID(data.docs[0].id)
            let finalData = data.docs[0].data();
            setName(finalData.name)
            setEmail(finalData.email)
            setDate(finalData.date)
            setDescription(finalData.description)
            setApproved(finalData.approved)
            setPhone(finalData.phone)
            if(approved === false){
                apTextSet('❌')
            }else{
                apTextSet('✅')
            }
            
        })
        // db.collection("data")
        // .where("code", "==", code)
        // .get()
        // .then(function(querySnapshot) {
        //     querySnapshot.forEach(function(document) {
        //     document.ref.update({name: 'Josh' }); 
        //     });
        // });

        // db.collection("data").doc(id).update({name: "test"});

    })
        return(
            <div>
                {/* <Helmet>
                <meta charSet="utf-8" />
                <title>{name}</title>
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content={window.location} />
                <meta property="twitter:title" content={name}></meta>
                <meta property="twitter:description" content={description} />
                <meta name="description" content={description} />
                <meta property="og:url" content={window.location} />
                <meta property="og:title" content={name} />
                <meta property="og:description" content={description} />
                </Helmet> */}
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.4/css/all.css" integrity="sha384-DyZ88mC6Up2uqS4h/KRgHuoeGwBcD4Ng9SiP4dIRy0EXTlnuz47vAwmeGwVChigm" crossorigin="anonymous" />
                <center>
                    {/* <div className="user-header">
                        <div className="header-components">
                        <h3 className="user-name" id="title">
                        {name}
                        </h3>
                        <h6 className="user-description" id="description">
                        {description}
                        </h6>
                        </div>
                    </div> */}
                    <h1>Thank you for taking an appointment</h1><hr /><br />
                    <Card style={{ width: '28rem' }}>
                    <Card.Title>
                        <h3>Your appointment Receipt</h3>
                    </Card.Title>
                    <ListGroup variant="flush">
                        <ListGroup.Item><b>Approval</b>: {apText}</ListGroup.Item>
                        <ListGroup.Item><b>Client Name</b>: {name}</ListGroup.Item>
                        <ListGroup.Item><b>Client Phone</b>: {phone}</ListGroup.Item>
                        <ListGroup.Item><b>Client Email</b>: {email}</ListGroup.Item>
                        <ListGroup.Item><b>Client Appointment Date</b>: {date}</ListGroup.Item>
                        <ListGroup.Item><b>Query</b>: {description}</ListGroup.Item>
                    </ListGroup>
                    </Card>
                </center>
            </div>
        )
    }


export default Receipt